'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getLangLocale = require('./getLangLocale');

var _getLangLocale2 = _interopRequireDefault(_getLangLocale);

var _formatName = require('./formatName');

var _formatName2 = _interopRequireDefault(_formatName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formalNameLanguages = ['de', 'ja'];

exports.default = function (_ref, options) {
  var givenName = _ref.givenName,
      familyName = _ref.familyName,
      email = _ref.email;

  var locale = options && options.locale || (0, _getLangLocale2.default)();
  return formalNameLanguages.indexOf(locale) >= 0 || !givenName ? (0, _formatName2.default)({ firstName: givenName, lastName: familyName, email: email }, options) : givenName;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.297/js/utils/formatFriendlyName.js
// module id = 342
// module chunks = 0